export default "__VITE_ASSET__D1CoUc0H__"